export const PROPERTY_RELATIONS_VIEWS = {
  CLIENT: 'CLIENT',
  ORDER: 'ORDER',
  UNIT: 'UNIT'
}
